var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.path_to_types_with_id(_vm.type_id)}},[_c('v-btn',{attrs:{"small":"","color":_vm.types.chipscolor[_vm.type_id],"tile":""}},[_vm._v(_vm._s(_vm.types.typename[_vm.lang][_vm.type_id]))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }